/* eslint 'jsx-a11y/anchor-is-valid': 'off'  */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from 'react-router-dom';
import { Button, Col, Label, FormGroup, Modal } from 'reactstrap';
import { getAllResources } from '../../../../action/cultureAction';
import { SaveUserDetails, UpdateUserDetails, SaveUserDetailsforclient, ClearClientData } from '../../../../action/Administration/administrationAction';
import PasswordReset from './_ModalsForms/PasswordReset'; 
import { sendSingleAmplitudeEvent } from 'amplitude/amplitude';

export default function AddModifyUserSummary(){

    let UserID = -1, Data =[], IsEditUser = false, IsTCUser = false;
    let lUserID = "", lFName = "", lLastName = "", lEmail = "", lRole = "";

    /*state declaration*/
    const [redirectBack, setRedirectBack] = useState(false);
    const [redirectManageUser, setRedirectManageUser] = useState(false);
    const [resetModal, ResetModalPopup] = useState(false);

    /*ref declaration*/
    const inputRef = useRef({});

    /*map state to props*/
    const label = useSelector(state => state.CulturalLabelsRootReducer.SystemAdmin_LabelsBasedOnPreference);
    const ClientUserDetails = useSelector(state => state.InstallationsRootReducer.ClientSideUserData);
    const UserDetails = useSelector(state => state.InstallationsRootReducer.UserDeatils);

    /*map dispatch to props*/
    const dispatch = useDispatch();

    /*calling methods after component mounts*/
    useEffect(() => {
        if (label["ActionsAndSettings.UAText.Text"] === undefined)
            dispatch(getAllResources());
    }, []);

    const ReadData = (UserType) => { 
        Data = {
            "userId" : UserID,
            "IsNewUser" : UserType ? (UserID > 0 ? false : true) : UserType,
            "userName" : inputRef.current['lUser_Id'].innerText,
            "firstName" : inputRef.current['lFirst_Name'].innerText,
            "lastName" : inputRef.current['lLast_Name'].innerText,
            "emailAddress" : inputRef.current['lEmail_Addr'].innerText,
            "role" : inputRef.current['lUserRole'].innerText
        }
    }

    const EditProfile = () => {
        ReadData(false);
        dispatch(SaveUserDetailsforclient(Data));
        setRedirectBack(true);
    }

    const GoBack = () => {
        if(!IsEditUser){
            ReadData(true);
            dispatch(SaveUserDetailsforclient(Data));
            setRedirectBack(true);
        }
        else{
            setRedirectManageUser(true);
            dispatch(ClearClientData());
        }
    }

    const Finish = async() => {
        var l_Data = {
            "userId" : UserID,
            "userName" : inputRef.current['lUser_Id'].innerText,
            "firstName" : inputRef.current['lFirst_Name'].innerText,
            "lastName" : inputRef.current['lLast_Name'].innerText,
            "emailAddress" : inputRef.current['lEmail_Addr'].innerText,
            "password": ClientUserDetails.pwd,
            "role" : inputRef.current['lUserRole'].innerText
        }
        if (UserID > 0){
            sendSingleAmplitudeEvent("TS on TC Edit Profile")
            await dispatch(UpdateUserDetails(l_Data));
        }
        else{
            sendSingleAmplitudeEvent("TS on TC Create Profile ")
            await dispatch(SaveUserDetails(l_Data));
        }
        setRedirectManageUser(true);
        dispatch(ClearClientData());
    }

    const CloseResetModalPopup = () => {
        ResetModalPopup(false);
    }

    if (redirectBack) {
        return <Redirect to={"/SystemAdmin/AddModifyUser"} />
    }   
    if (redirectManageUser) {
        return <Redirect to={"/SystemAdmin/ManageUsers"} />
    }

    if(ClientUserDetails !== undefined && ClientUserDetails !== null && ClientUserDetails.userName !== undefined){
        UserID = ClientUserDetails.userId;
        lUserID = ClientUserDetails.userName;
        lFName = ClientUserDetails.firstName;
        lLastName = ClientUserDetails.lastName;
        lEmail = ClientUserDetails.emailAddress;
        lRole = ClientUserDetails.role;
        IsEditUser = false;
    }else{
        IsEditUser = true;
    }

    if (UserDetails !== undefined && UserDetails !== "" && UserDetails.userName !== undefined && IsEditUser) {
        UserID = UserDetails.userId;
        lUserID = UserDetails.userName;
        lFName = UserDetails.firstName;
        lLastName = UserDetails.lastName;
        lEmail = UserDetails.emailAddress;
        lRole = UserDetails.role;
        IsTCUser = UserDetails.isTraneConnectUser;
    }

    return(
        <div className="dbd_container">
            <div className="admin_page_titlebar">
                <div className="admin_subheader">
                    <h2 className="dbd_sub_heading">{IsEditUser ? "User Profile Details" : "User Profile Summary"}</h2>
                </div>
            </div> 
            <table>
                <tr>
                    <td>
                        <div className="main_container dbd_main_container">
                            <legend className="form_sub_title">Personal Information</legend>
                            <div className="add_modifi form_group TableHeaderLeft TableContentDisplay">
                                <Label className="Custom_label">{label['ActionsAndSettings.UserRole.UserProfile.Text'] !== undefined ? label['ActionsAndSettings.UserRole.UserProfile.Text'] : "User Profile"}</Label>
                                { (IsEditUser && !IsTCUser) ?
                                    <label className="blue_link link_cursor" style={{fontWeight:'500'}} onClick={() => EditProfile()}>{label['ManageDatabaseMaintenance.btnEdit.Text'] !== undefined ? label['ManageDatabaseMaintenance.btnEdit.Text'] : "Edit"}</label>
                                    :<></>
                                }
                            </div>
                            <div className="add_modifi form_group TableBaseRow TableContentDisplay">
                                <Label className="Custom_label">{label['EnumUserChangeLog.cboForColumn.1.Text'] !== undefined ? label['EnumUserChangeLog.cboForColumn.1.Text'] : "User ID"} </Label>
                                <label className="Custom_label" ref={el => inputRef.current['lUser_Id'] = el}>{lUserID}</label>
                            </div>
                            {
                                IsEditUser && !IsTCUser ?
                                    <div className="add_modifi form_group TableBaseRow TableContentDisplay">
                                        <Label className="Custom_label">{label['ConfigureADDServices.lblADDPassword.Text'] !== undefined ? label['ConfigureADDServices.lblADDPassword.Text'] : "Password"} </Label>
                                        <a onClick={() => ResetModalPopup(true)} className="nv_link link_cursor">{label['UserChangeLog.TransactionType.98.Text'] !== undefined ? label['UserChangeLog.TransactionType.98.Text'] : "Reset Password"}</a>
                                    </div> : ""
                            }
                            <div className="add_modifi form_group TableBaseRow TableContentDisplay">
                                <Label className="Custom_label">{label['ApplyForSiteLicenseMail.FirstName.Text'] !== undefined ? label['ApplyForSiteLicenseMail.FirstName.Text'] : "First Name"}</Label>
                                <label className="Custom_label" ref={el => inputRef.current['lFirst_Name'] = el}>{lFName}</label>
                            </div>
                            <div className="add_modifi form_group TableBaseRow TableContentDisplay">
                                <Label className="Custom_label">{label['ApplyForSiteLicenseMail.LastName.Text'] !== undefined ? label['ApplyForSiteLicenseMail.LastName.Text'] : "Last Name"}</Label>
                                <label className="Custom_label" ref={el => inputRef.current['lLast_Name'] = el}>{lLastName}</label>
                            </div>
                            <div className="add_modifi form_group TableBaseRow TableContentDisplay">
                                <Label className="Custom_label">{label['AddAlarmEmailRouting2.ColHeader.Text'] !== undefined ? label['AddAlarmEmailRouting2.ColHeader.Text'] : "E-mail Address"}</Label>
                                <label className="Custom_label" ref={el => inputRef.current['lEmail_Addr'] = el}>{lEmail}</label>
                            </div>
                            <div className="add_modifi form_group TableBaseRow TableContentDisplay">
                                <Label className="Custom_label">{label['ActionsAndSettings.UserRole.Text'] !== undefined ? label['ActionsAndSettings.UserRole.Text'] : "User Role"}</Label>
                                <label className="Custom_label" ref={el => inputRef.current['lUserRole'] = el}>{lRole}</label>
                            </div>
                            <FormGroup row className="btns_group">
                                <Col sm={{ size: 10 }}>
                                    <Button className="btn-gray btn-md" onClick={() => GoBack()}>{label['ManageTroubleshootingManuals.BackButton.Text'] !== undefined ? label['ManageTroubleshootingManuals.BackButton.Text'] : "< Back"}</Button>
                                    <Button className="btn-success btn-md" hidden={IsEditUser} onClick={() => Finish()} >{label['AddFixedChoiceBuildingCustomAttributesConfirm.btnFinish.Text'] !== undefined ? label['AddFixedChoiceBuildingCustomAttributesConfirm.btnFinish.Text'] : "Finish"}</Button>
                                </Col>
                            </FormGroup>
                        </div>
                    </td>
                </tr>
            </table>
            <Modal isOpen={resetModal}>
                <PasswordReset ResetModalPopup={CloseResetModalPopup} UserName={lUserID} MailAddress={lEmail} UserID={UserID} />
            </Modal>
        </div>
    );
}